<template>
    <v-container class="login p-0" fluid>
        <vue-headful :title="$t('header.login') + $t('title')"></vue-headful>
        <HkiaraceBannerFrame
            :label="$t('login.title')"
            :is-snap-content="true">
            <div class="form-div">
                <v-form>
                    <v-row>
                        <v-col>
                            <v-row class="form-title title-font">{{$t('register.login_info')}}</v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                                    :label="$t('login.username')"
                                                    :placeholder="$t('login.username')"
                                                    v-model="username"
                                                    autocomplete="username"
                                                    @keyup.enter="login"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                                    :label="$t('login.password')"
                                                    :placeholder="$t('login.password')"
                                                    v-model="password"
                                                    autocomplete="current-password"
                                                    @keyup.enter="login"
                                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    @click:append="showPassword = !showPassword"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="text-left">
                                    <v-btn dark
                                        rounded
                                        x-large
                                        color="rgb(142, 118, 91)"
                                        @click="login"
                                        class="function-button login-btn">
                                        {{$t('header.login')}}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="text-left">
                                    <router-link :to="{name: 'reset-password-init'}" class="forgot-pw-link">{{$t('login.forgot_password')}}</router-link>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
        </HkiaraceBannerFrame>

        <b-modal id="remindChangePasswordModal"
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc
                 centered
                 siz="sm">
            <b-container class="remind-change-password-container">
                <b-row class="mb-3">
                    <b-col class="remind-change-password-title text-center">
                        {{$t('remind_change_password.modal_title')}}
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col class="remind-change-password-content">
                        {{$t('remind_change_password.modal_content')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button class="remind-change-password-btn"
                                  block
                                  @click="$router.push({name: 'my-account'})">
                            {{$t('remind_change_password.skip')}}
                        </b-button>
                    </b-col>
                    <b-col>
                        <b-button class="remind-change-password-btn"
                                  block
                                  variant="primary"
                                  @click="$router.push({name: 'change-password'})">
                            {{$t('remind_change_password.change_password')}}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </v-container>
</template>

<script>
    import {DateTime} from 'luxon'
    import HkiaraceBannerFrame from "../../components/HkiaraceBannerFrame";

    export default {
        name: 'Login',
        components: {HkiaraceBannerFrame},
        data() {
            return {
                username: '',
                password: '',
                showPassword: false,
                pageWidth: window.innerWidth
            };
        },
        mounted() {
            this.pageWidth = window.innerWidth;
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.pageWidth = window.innerWidth;
                });
            })
          this.parseNextParams();
        },
        watch: {
            currentUser(newVal, oldVal) {
                if (!oldVal.id && newVal.id) {
                    let idExpiryDate = newVal.id_expiry_date ? DateTime.fromISO(newVal.id_expiry_date) : null;

                    // if (newVal.type === 369 || newVal.type === 100) {
                    //     this.$router.replace({name: 'acc-booking'});
                    // } else if (!newVal.id_no || (idExpiryDate && new Date() > idExpiryDate)) {
                    //     this.$router.replace({name: 'id-verify', query: {after: this.$route.query.after}});
                    // } else

                    // if (!newVal.id_no || (idExpiryDate && new Date() > idExpiryDate)) {
                    //     this.$router.replace({name: 'id-verify', query: {after: this.$route.query.after}});
                    // } else

                    // if (newVal.last_password_change && new Date() > DateTime.fromISO(newVal.last_password_change).plus({days: 90})) {
                    //     this.$bvModal.show("remindChangePasswordModal");
                    // } else

                    if (this.$route.query.after) {
                        this.$router.replace({path: this.$route.query.after});
                    } else {
                        this.$router.replace({name: 'home'});
                    }
                }
            },
        },
        computed: {
            currentUser() {
                return this.$store.state.user;
            },
        },
        methods: {
          parseNextParams() {
            const urlParams = this.$route.query
            const nextUrl = urlParams["next"]
            this.login_api = "hkiarace/login/"
            this.is_oauth = false

            if (nextUrl) {
              const nextParams = new URLSearchParams(
                  new URL(window.location.origin + nextUrl).search
              );
              this.response_type = nextParams.get("response_type") || "";
              this.client_id = nextParams.get("client_id") || "";
              this.redirect_uri = nextParams.get("redirect_uri") || "";
              this.nonce = nextParams.get("nonce") || "";
              this.scope = nextParams.get("scope") || "";
              this.next_url = nextUrl; // Store next URL path
              this.login_api = "hkiarace/oauth2-login/"
              this.is_oauth = true
            }
          },
          login() {
            if (this.username && this.password) {
              this.$callAPI(this.login_api, {
                username: this.username,
                password: this.password,
                response_type: this.response_type,
                client_id: this.client_id,
                redirect_uri: this.redirect_uri,
                nonce: this.nonce,
                scope: this.scope
              }, function () {
                if (this.is_oauth) {
                  window.location.href = this.next_url.startsWith("/")
                      ? window.location.origin + this.next_url
                      : this.next_url;
                } else {
                  this.$storeDispatch('getMe');
                }

              }, function (response) {
                if (response.status === 401) {
                  switch (response.body.msg) {
                      case 'locked_account_error':
                          this.$showAlertMessage(this.$t('login.locked_account_error'));
                          break;
                      case 'disabled_account_error':
                          this.$showAlertMessage(this.$t('login.disabled_account_error'));
                          break;
                      case 'account_not_approved_error':
                          this.$showAlertMessage(this.$t('login.account_not_approved_error'));
                          break;
                      case 'password_expired_error':
                          this.$showAlertMessage(this.$t('login.password_expired_error'));
                          break
                      default:
                          this.$showAlertMessage(this.$t('login.wrong_password'))
                  }
                } else {
                  if (response.body.verify_email) {
                    this.$router.push({name: 'email-verify-init'});
                  } else if (response.body.verify_device) {
                    this.$router.push({name: 'device-verify', query: {after: this.$route.query.after, next: this.next_url}});
                  }
                }
              });
              this.password = '';
            }
          },

        }
    }
</script>

<style lang="less">
    .login {
        .form-div {
            padding: 16px 10% 24px 10%;
            background-color: white;

            .form-title {
                font-size: 1.5rem;
                padding-top: 32px;
                padding-bottom: 16px;
                padding-left: 12px;
            }

            .v-input {
                border-radius: 0;
            }
        }

        .forgot-pw-link {
            color: #798188;
        }

        .login-btn {
            &.v-btn--disabled {
                background-color: rgba(142, 118, 91, 0.5) !important;
                border-color: rgba(142, 118, 91, 0.5) !important;
                color: white !important;
            }
        }
    }

    .remind-change-password-container {
        padding: 50px;

        .remind-change-password-title {
            font-size: 2rem;

        }

    }


    @media only screen and (min-width: 600px) {
        .form-div {
            top: calc(20% - 5rem) !important;
        }
    }

    @media only screen and (min-width: 820px) {
        .form-div {
            top: calc(20% - 10rem) !important;;
        }
    }

    @media only screen and (min-width: 960px) {
        .form-div {
            top: calc(20%) !important;;
        }
    }

    @media only screen and (min-width: 1248px) {
        .form-div {
            top: calc(20% + 5rem) !important;
        }
    }
</style>
